/**
 * Sidebar icon registry for app modules.
 *
 * Maps `sidebar.iconName` strings from `appModuleDefinitions.js` to icon components.
 * Add a new key here when introducing a new `iconName` in module definitions.
 *
 * @module modules/appModuleIcons
 */

import { CalendarOutlined, HomeOutlined, SettingOutlined } from "@ant-design/icons";
import { FiCode } from "react-icons/fi";
import { HiOutlineClipboardDocumentCheck, HiOutlineFolder } from "react-icons/hi2";
import {
  MdOutlineAccountTree,
  MdOutlineBusiness,
  MdOutlineDescription,
  MdOutlineFactCheck,
} from "react-icons/md";

/** @type {Record<string, React.ComponentType>} */
export const ICONS_BY_NAME = {
  CalendarOutlined,
  FiCode,
  HiOutlineClipboardDocumentCheck,
  HiOutlineFolder,
  HomeOutlined,
  MdOutlineAccountTree,
  MdOutlineBusiness,
  MdOutlineDescription,
  MdOutlineFactCheck,
  SettingOutlined,
};

/**
 * Resolve a sidebar icon component from its registry name.
 *
 * @param {string} iconName
 * @returns {React.ComponentType}
 */
export function getModuleIcon(iconName) {
  const Icon = ICONS_BY_NAME[iconName];

  if (!Icon) {
    throw new Error(`Unknown sidebar iconName "${iconName}"`);
  }

  return Icon;
}
